
import { ITopBarRef, TopBar } from '../../../com/flyerPages/topBar/TopBar'
import { FlyerPages } from './flyerPages/FlyerPages'

import './FlyerEditorContent.scss'
import {FlyerDto, SelectPageForTabsDto} from '../../../../dtos'
import {useEffect, useRef, useState} from 'react'
import {useTypedSelector} from "../../../../hooks/useTypeSelector";

interface IFlyerEditorContent {
    data?: FlyerDto
}

export const FlyerEditorContent: React.FC<IFlyerEditorContent> = (props) => {
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const topBarReference = useRef<ITopBarRef>(null)

    const [pageIndex, setPageIndex] = useState(1)

    const onPageIndexChanges = (index: number) => {
        setPageIndex(index)
    }

    useEffect(() => {
        setPageIndex(selectedPageState.pageNo === 0 ? 0 : selectedPageState.pageNo - 1);
    }, [selectedPageState.pageNo])

    return (
        <div className="flyer_promo_items_editor_content">
            <TopBar 
                ref={topBarReference}
                total={props.data?.flyerPages?.length!}
                onPageIndexChanges={onPageIndexChanges}
                pageIndex={pageIndex}
            />
            <FlyerPages 
                data={props.data} 
                pageIndex={pageIndex}
                onLeftArrowClick={() => topBarReference.current!.showBack()}
                onNextArrowClick={() => topBarReference.current!.showNext()}
            />
        </div>
    )
}